import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ComplexModalTemplate } from '@connect-services/client/components/complexe-modal/complex-modal-template.component';
import { UpdateFieldInterventionService } from '@connect-services/client/services/update-field-intervention.service';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { ProgressBarComponent } from '@shared/client/components/progress-bar/progress-bar.component';

type UpdatePlanningProgressModalData = {
    descriptionKey: string;
    titleKey: string;
};

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ComplexModalTemplate, ProgressBarComponent, RessourcesModule],
    selector: 'app-update-planning-progress-modal',
    templateUrl: './update-planning-progress-modal.component.html',
})
export class UpdatePlanningProgressModalComponent {
    protected readonly data: UpdatePlanningProgressModalData = inject(MAT_DIALOG_DATA);
    protected readonly updateFieldInterventionService = inject(UpdateFieldInterventionService);
}
